import React from 'react';
import { Form } from 'react-bootstrap';


const ClassSelectionStep = ({
  classOptions,
  selectedOptionId,
  onSelectOption,
  formatLabel,
}) => (
  <>
    <p className="class-modal-subtitle">
      What Event Date and Time Are You Interested in? <span>*</span>
    </p>
    {classOptions.length ? (
      <Form className="class-modal-options">
        {classOptions.map((option) => (
          <Form.Check
            key={option.optionId}
            type="radio"
            name="classModalOption"
            id={`class-option-${option.optionId}`}
            label={formatLabel(option.classItem, option.time, option.dayName, option.city)}
            checked={selectedOptionId === option.optionId}
            onChange={() => onSelectOption(option.optionId)}
            className="class-modal-option"
          />
        ))}
      </Form>
    ) : (
      <p className="class-modal-empty">No classes are available for this location.</p>
    )}
  </>
);

export default ClassSelectionStep;
